import React, { useState } from 'react';
import api from '../utils/api';

const LABEL = 'block text-[10px] font-bold uppercase tracking-[0.05em] text-surface-muted mb-1';
const INPUT = 'w-full px-[10px] py-2 bg-surface-base text-surface-text border border-surface-border text-xs focus:outline-none focus:ring-2 focus:ring-accent rounded-[2px]';

export default function AddAccountForm({ onAdded }) {
  const [steamId64, setSteamId64] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!steamId64.trim()) { setError('Please enter a SteamID64.'); return; }
    if ((username && !password) || (!username && password)) {
      setError('Provide both username and password, or neither.');
      return;
    }
    const payload = { steamId64: steamId64.trim() };
    if (username && password) { payload.username = username.trim(); payload.password = password; }
    try {
      await api.post('/api/accounts', payload);
      setSteamId64(''); setUsername(''); setPassword('');
      onAdded();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to add account.');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {error && <div className="text-steam-danger text-xs mb-3">{error}</div>}
      <label className={LABEL}>SteamID64</label>
      <input className={`${INPUT} font-mono mb-[14px]`} placeholder="76561198…" value={steamId64} onChange={(e) => setSteamId64(e.target.value)} />
      <label className={LABEL}>Credentials <span className="text-accent normal-case">(optional)</span></label>
      <input className={INPUT + ' mb-2'} placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} />
      <input type="password" className={INPUT + ' mb-4'} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
      <div className="text-[10px] text-surface-muted mb-4 leading-snug">
        Credentialed accounts get CS2 cooldown tracking. Provide both fields or neither — partial is rejected.
      </div>
      <div className="flex gap-2 justify-end">
        <button type="submit" className="px-[14px] py-2 bg-accent text-surface-base border-0 text-[11px] font-bold uppercase tracking-wider rounded-[2px]">Add</button>
      </div>
    </form>
  );
}
